export type LeadSource =
  | 'google'
  | 'spotify'
  | 'kidsinadelaide'
  | 'facebook'
  | 'tiktok'
  | 'instagram'
  | 'x'
  | 'linkedin'
  | 'flyers'
  | 'youtube'
  | 'blog'
  | 'signage'
  | 'referral'
  | 'giftcard'
  | 'newsletter'
  | 'chatgpt'
  | 'perplexity'
  | 'aisearch'
  | 'open_day';

export const leadSourceLabels: Record<LeadSource, string> = {
  google: 'Google Search',
  spotify: 'Spotify',
  kidsinadelaide: 'Kids In Adelaide Page / Websites',
  facebook: 'Facebook',
  tiktok: 'TikTok',
  instagram: 'Instagram',
  x: 'X (Twitter)',
  linkedin: 'Linkedin',
  flyers: 'Flyers / Poster',
  youtube: 'YouTube',
  signage: 'Signage / Storefront',
  referral: 'Word of Mouth / Referral',
  giftcard: 'Gift Card',
  blog: 'Blog',
  newsletter: 'Newsletter',
  chatgpt: 'ChatGPT',
  perplexity: 'Perplexity',
  aisearch: 'AI Search (Other)',
  open_day: 'Open Day / Studio Visit',
};
